import AdminLayout from "../../../components/admin/layout/AdminLayout";
import CreateAdminProject from "../../../components/admin/project/CreateAdminProject";

const AdminCreateProjectPage: React.FC = () => {
    return(
        <AdminLayout>
            <CreateAdminProject/>
        </AdminLayout>
    )
}

export default AdminCreateProjectPage;